import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss'],
  standalone: false
})
export class LogoutModalComponent {
  @Input() open: boolean = false;
  @Output() dismiss = new EventEmitter<any>();

  constructor() { }

  onCancel() {
    this.dismiss?.emit();
  }
}
